// Mock data for TALITHA KOUMI TUG - Tu es une Guerrière website

export const translations = {
  en: {
    // Top Bar
    slogan: "TALITHA KOUMI · YOU ARE A WARRIOR",
    signUp: "Sign up",
    contact: "Contact",
    search: "Search",

    // Navigation (sentence case)
    whoWeAre: "Who we are",
    ourPrograms: "Our programs",
    takeAction: "Take action",
    eventsNav: "Events",
    newsStories: "News & stories",
    donate: "DONATE",

    // Hero Slides
    heroSlides: [
      {
        id: 0,
        title: "OTTAWA INTERNATIONAL CONFERENCE 2027",
        subtitle: "How to recover after abuse, rape, harassment, mistreatment and trauma. March 12–14, 2027 at the Sheraton Hotel, Ottawa.",
        cta: "REGISTER NOW",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/n2geeql4_file_00000000e4dc722f93e14f7e2b511ce8.png",
        link: "/conference-registration"
      },
      {
        id: 4,
        title: "THE OFFICIAL 2027 FLYER IS HERE",
        subtitle: "Download, share and spread the word about the 2nd edition of our international conference for young women.",
        cta: "VIEW & SHARE THE FLYER",
        image: "https://customer-assets-cm19k8pv.emergentagent.net/job_e8d2b5f5-0cb7-4419-b7f1-41d20d77a12b/artifacts/f8dy9jim_IMG-20260820-WA0166.jpg",
        link: "/events"
      },
      {
        id: 1,
        title: "EMPOWERING YOUNG GIRLS",
        subtitle: "Being a young girl is not synonymous with idleness. Together, we equip young women with teachings and workshops for their growth and success.",
        cta: "JOIN OUR MOVEMENT",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/uuuo93ic_file_0000000073b8722fa193c83492ef83e4.png"
      },
      {
        id: 2,
        title: "POTENTIAL YOUNG WOMEN",
        subtitle: "Our panel discussions bring together inspiring women to share their experiences and empower the next generation of leaders.",
        cta: "LEARN MORE",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/e5puakeh_FB_IMG_1769016817587.jpg"
      },
      {
        id: 3,
        title: "JOIN OUR COMMUNITY",
        subtitle: "Join us at our annual conference, bringing together over 500 young girls for workshops, talk shows and empowerment sessions.",
        cta: "REGISTER NOW",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/u4ct7pnl_file_00000000ffa4722f9243b515e4a1db6e.png"
      }
    ],

    // Stats
    stats: [
      { number: "500+", label: "young girls reached through our programs", icon: "users" },
      { number: "15+", label: "workshops and conferences organized", icon: "calendar" },
      { number: "3", label: "countries with active programs", icon: "globe" }
    ],

    // Mission Section
    missionTitle: "EMPOWERING. EDUCATING. TRANSFORMING.",
    missionHighlight: "TOGETHER.",
    missionDescription: "TALITHA KOUMI TUG is an international organization dedicated to empowering young girls through education, awareness and personal development. We work in three critical areas:",
    missionAreas: [
      {
        title: "EDUCATION & WORKSHOPS",
        description: "We provide teachings and workshops that contribute to the growth and development of young girls."
      },
      {
        title: "CONFERENCES & EVENTS",
        description: "We organize conferences, talk shows and awareness sessions to inspire and motivate young women."
      },
      {
        title: "SUPPORT & HEALING",
        description: "We act as a clinic for young girls who have suffered abuse, helping them realize their full potential."
      }
    ],

    // Programs Section (sentence case for titles)
    programsTitle: "Our programs",
    programsSubtitle: "Discover how we are making a difference",
    programs: [
      {
        id: 1,
        title: "Young girl education project",
        description: "Education and awareness program for young girls aged 13 to 30 in the Democratic Republic of Congo.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/3cgr0omd_file_00000000e85c71f7a32eb3f83d3c976c.png"
      },
      {
        id: 2,
        title: "Leadership workshops",
        description: "Interactive workshops helping young women discover their talents and develop leadership skills.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/d2v83ahb_FB_IMG_1769023522592.jpg"
      },
      {
        id: 3,
        title: "Annual conference",
        description: "Our flagship event, bringing together hundreds of young girls for empowerment and networking.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/uuuo93ic_file_0000000073b8722fa193c83492ef83e4.png"
      }
    ],

    // Events Section
    eventsTitle: "Upcoming events",
    eventsSubtitle: "Join us at our next gathering",
    events: [
      {
        id: 1,
        title: "Ottawa Conference 2027 — How to recover after trauma",
        date: "March 12–14, 2027",
        location: "Sheraton Hotel, 150 Albert St, Ottawa",
        description: "How to recover after abuse, rape, harassment, mistreatment and trauma. Join us for this powerful healing conference.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/n2geeql4_file_00000000e4dc722f93e14f7e2b511ce8.png"
      },
      {
        id: 2,
        title: "Leadership workshop series",
        date: "September 5, 2025",
        location: "Gatineau, Canada",
        description: "Interactive workshop on discovering your talents and developing leadership skills.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/k6tuzj7t_file_00000000f710722fa67766610c5f8445.png"
      },
      {
        id: 3,
        title: "Youth talk show — Rising warriors",
        date: "October 12, 2025",
        location: "Online event",
        description: "Virtual talk show featuring inspiring stories from young women who have overcome challenges.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/p74pt2xl_file_00000000b4d871f591d4e18e08793fa4.png"
      }
    ],

    // News Section
    newsTitle: "Latest news and stories",
    newsSubtitle: "Stay updated on our impact",
    news: [
      {
        id: 1,
        title: "500 young girls empowered at the Kinshasa conference",
        date: "June 15, 2024",
        excerpt: "Our recent conference in Kinshasa brought together over 500 young girls for workshops and empowerment sessions.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/yyzrhj9w_FB_IMG_1769023498822.jpg"
      },
      {
        id: 2,
        title: "New partnership with local media channels",
        date: "May 20, 2024",
        excerpt: "We are excited to announce partnerships with B-One TV, RTCE and RTNC for live broadcast coverage.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/k6tuzj7t_file_00000000f710722fa67766610c5f8445.png"
      },
      {
        id: 3,
        title: "Expanding our reach to Canada",
        date: "April 10, 2024",
        excerpt: "TALITHA KOUMI TUG is now organizing workshops and events in Gatineau, Quebec, reaching the diaspora community.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/g22ouhus_file_000000002bec722f8465457c56e0d757.png"
      }
    ],

    // Newsletter
    newsletterTitle: "JOIN US",
    newsletterPlaceholder: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email"
    },
    newsletterButton: "SIGN UP",
    newsletterConsent: "I would like to receive email updates from TALITHA KOUMI TUG. I understand I can unsubscribe at any time.",

    // Footer
    footerSlogan: "Empowering young girls begins with education and awareness.",
    footerLinks: {
      joinMovement: "Join our movement",
      volunteer: "Volunteer with us",
      stories: "Discover our stories",
      research: "Explore our research"
    },
    footerContact: {
      email: "info@talithakoumitug.com",
      phone: "613-406-3868",
      address: "427-2100 Russell Road, K1G 3W7, Ottawa, Ontario"
    },
    footerLegal: {
      privacy: "Privacy policy",
      accessibility: "Accessibility",
      careers: "Careers",
      about: "About us"
    },
    shareThisPage: "SHARE THIS PAGE",
    copyright: "© 2025 TALITHA KOUMI TUG — Tu es une Guerrière. All rights reserved."
  },
  fr: {
    // Top Bar
    slogan: "TALITHA KOUMI · TU ES UNE GUERRIÈRE",
    signUp: "S’inscrire",
    contact: "Contact",
    search: "Rechercher",

    // Navigation (en français, on capitalise uniquement le premier mot)
    whoWeAre: "Qui sommes-nous",
    ourPrograms: "Nos programmes",
    takeAction: "Agir",
    eventsNav: "Événements",
    newsStories: "Actualités",
    donate: "FAIRE UN DON",

    // Hero Slides
    heroSlides: [
      {
        id: 0,
        title: "CONFÉRENCE INTERNATIONALE OTTAWA 2027",
        subtitle: "Comment se relever après les abus, le viol, le harcèlement, la maltraitance et le traumatisme. Du 12 au 14 mars 2027, à l’hôtel Sheraton, Ottawa.",
        cta: "S’INSCRIRE MAINTENANT",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/n2geeql4_file_00000000e4dc722f93e14f7e2b511ce8.png",
        link: "/conference-registration"
      },
      {
        id: 4,
        title: "L’AFFICHE OFFICIELLE 2027 EST ARRIVÉE",
        subtitle: "Téléchargez, partagez et faites connaître la 2ᵉ édition de notre conférence internationale pour la jeune fille.",
        cta: "VOIR ET PARTAGER L’AFFICHE",
        image: "https://customer-assets-cm19k8pv.emergentagent.net/job_e8d2b5f5-0cb7-4419-b7f1-41d20d77a12b/artifacts/f8dy9jim_IMG-20260820-WA0166.jpg",
        link: "/events"
      },
      {
        id: 1,
        title: "AUTONOMISER LES JEUNES FILLES",
        subtitle: "Être une jeune fille n’est pas synonyme d’oisiveté. Ensemble, nous équipons les jeunes femmes par des enseignements et des ateliers pour leur épanouissement et leur réussite.",
        cta: "REJOIGNEZ NOTRE MOUVEMENT",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/uuuo93ic_file_0000000073b8722fa193c83492ef83e4.png"
      },
      {
        id: 2,
        title: "JEUNES FILLES POTENTIELLES",
        subtitle: "Nos panels réunissent des femmes inspirantes qui partagent leur expérience et autonomisent la prochaine génération de leaders.",
        cta: "EN SAVOIR PLUS",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/e5puakeh_FB_IMG_1769016817587.jpg"
      },
      {
        id: 3,
        title: "REJOIGNEZ NOTRE COMMUNAUTÉ",
        subtitle: "Rejoignez-nous à notre conférence annuelle qui réunit plus de 500 jeunes filles pour des ateliers, des talk-shows et des séances d’autonomisation.",
        cta: "INSCRIVEZ-VOUS",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/u4ct7pnl_file_00000000ffa4722f9243b515e4a1db6e.png"
      }
    ],

    // Stats
    stats: [
      { number: "500+", label: "jeunes filles touchées par nos programmes", icon: "users" },
      { number: "15+", label: "ateliers et conférences organisés", icon: "calendar" },
      { number: "3", label: "pays où nos programmes sont actifs", icon: "globe" }
    ],

    // Mission Section
    missionTitle: "AUTONOMISER. ÉDUQUER. TRANSFORMER.",
    missionHighlight: "ENSEMBLE.",
    missionDescription: "TALITHA KOUMI TUG est une organisation internationale qui œuvre à l’autonomisation des jeunes filles par l’éducation, la sensibilisation et le développement personnel. Nous intervenons dans trois domaines essentiels :",
    missionAreas: [
      {
        title: "ÉDUCATION & ATELIERS",
        description: "Nous offrons des enseignements et des ateliers qui contribuent à l’épanouissement et au développement des jeunes filles."
      },
      {
        title: "CONFÉRENCES & ÉVÉNEMENTS",
        description: "Nous organisons des conférences, des talk-shows et des séances de sensibilisation pour inspirer et motiver les jeunes femmes."
      },
      {
        title: "SOUTIEN & GUÉRISON",
        description: "Nous accompagnons les jeunes filles victimes d’abus afin qu’elles réalisent pleinement leur potentiel."
      }
    ],

    // Programs Section
    programsTitle: "Nos programmes",
    programsSubtitle: "Découvrez comment nous faisons la différence",
    programs: [
      {
        id: 1,
        title: "Projet d’éducation des jeunes filles",
        description: "Programme d’éducation et de sensibilisation pour les jeunes filles de 13 à 30 ans en République démocratique du Congo.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/3cgr0omd_file_00000000e85c71f7a32eb3f83d3c976c.png"
      },
      {
        id: 2,
        title: "Ateliers de leadership",
        description: "Ateliers interactifs qui aident les jeunes femmes à découvrir leurs talents et à développer leurs compétences en leadership.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/d2v83ahb_FB_IMG_1769023522592.jpg"
      },
      {
        id: 3,
        title: "Conférence annuelle",
        description: "Notre événement phare, qui réunit des centaines de jeunes filles pour l’autonomisation et le réseautage.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/uuuo93ic_file_0000000073b8722fa193c83492ef83e4.png"
      }
    ],

    // Events Section
    eventsTitle: "Événements à venir",
    eventsSubtitle: "Rejoignez-nous lors de notre prochain rassemblement",
    events: [
      {
        id: 1,
        title: "Conférence Ottawa 2027 — Comment se relever après un traumatisme",
        date: "Du 12 au 14 mars 2027",
        location: "Hôtel Sheraton, 150 rue Albert, Ottawa",
        description: "Comment se relever après les abus, le viol, le harcèlement, la maltraitance et le traumatisme. Rejoignez-nous pour cette puissante conférence de guérison.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/n2geeql4_file_00000000e4dc722f93e14f7e2b511ce8.png"
      },
      {
        id: 2,
        title: "Série d’ateliers de leadership",
        date: "5 septembre 2025",
        location: "Gatineau, Canada",
        description: "Atelier interactif sur la découverte de vos talents et le développement de compétences en leadership.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/k6tuzj7t_file_00000000f710722fa67766610c5f8445.png"
      },
      {
        id: 3,
        title: "Talk-show jeunesse — Guerrières en devenir",
        date: "12 octobre 2025",
        location: "Événement en ligne",
        description: "Talk-show virtuel mettant en lumière les histoires inspirantes de jeunes femmes qui ont surmonté de grands défis.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/p74pt2xl_file_00000000b4d871f591d4e18e08793fa4.png"
      }
    ],

    // News Section
    newsTitle: "Dernières actualités",
    newsSubtitle: "Restez informé de notre impact",
    news: [
      {
        id: 1,
        title: "500 jeunes filles autonomisées à la Conférence de Kinshasa",
        date: "15 juin 2024",
        excerpt: "Notre récente conférence à Kinshasa a réuni plus de 500 jeunes filles autour d’ateliers et de séances d’autonomisation.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/yyzrhj9w_FB_IMG_1769023498822.jpg"
      },
      {
        id: 2,
        title: "Nouveau partenariat avec les chaînes médiatiques locales",
        date: "20 mai 2024",
        excerpt: "Nous sommes heureux d’annoncer de nouveaux partenariats avec B-One TV, RTCE et RTNC pour la couverture en direct.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/k6tuzj7t_file_00000000f710722fa67766610c5f8445.png"
      },
      {
        id: 3,
        title: "Extension de notre portée au Canada",
        date: "10 avril 2024",
        excerpt: "TALITHA KOUMI TUG organise désormais des ateliers et des événements à Gatineau, au Québec, auprès de la communauté de la diaspora.",
        image: "https://customer-assets.emergentagent.com/job_talitha-koumi/artifacts/g22ouhus_file_000000002bec722f8465457c56e0d757.png"
      }
    ],

    // Newsletter
    newsletterTitle: "REJOIGNEZ-NOUS",
    newsletterPlaceholder: {
      firstName: "Prénom",
      lastName: "Nom",
      email: "Courriel"
    },
    newsletterButton: "S’INSCRIRE",
    newsletterConsent: "Je souhaite recevoir des mises à jour par courriel de TALITHA KOUMI TUG. Je peux me désabonner à tout moment.",

    // Footer
    footerSlogan: "L’autonomisation des jeunes filles commence par l’éducation et la sensibilisation.",
    footerLinks: {
      joinMovement: "Rejoindre notre mouvement",
      volunteer: "Devenir bénévole",
      stories: "Découvrir nos histoires",
      research: "Explorer nos recherches"
    },
    footerContact: {
      email: "info@talithakoumitug.com",
      phone: "613-406-3868",
      address: "427-2100 Russell Road, K1G 3W7, Ottawa, Ontario"
    },
    footerLegal: {
      privacy: "Politique de confidentialité",
      accessibility: "Accessibilité",
      careers: "Carrières",
      about: "À propos"
    },
    shareThisPage: "PARTAGER CETTE PAGE",
    copyright: "© 2025 TALITHA KOUMI TUG — Tu es une Guerrière. Tous droits réservés."
  }
};

export default translations;
